import {FC} from 'react'
import classNames from 'classnames'
import {RenderIf} from 'components/Basic/RenderIf'
import {ArrowIcon, TriangleWarningIcon} from 'components/Basic/SvgIcon'

interface ImportPrerequisiteProps {
  message: string
  hideIcon?: boolean
  classes?: string
  dataCy?: string
}
export const ImportPrerequisite: FC<ImportPrerequisiteProps> = ({
  message,
  hideIcon = false,
  classes = '',
  dataCy,
}) => {
  return (
    <div
      className={classNames(
        'max-w-150 p-3 flex items-center justify-center border border-yellow-100 bg-yellow-100 bg-opacity-20',
        classes,
      )}
      data-cy={dataCy}
    >
      <RenderIf isTrue={!hideIcon}>
        <div className="mr-3">
          <TriangleWarningIcon
            strokeColor="text-yellow-100"
            height={24}
            width={24}
          />
        </div>
      </RenderIf>
      <p className="karla text-sm">
        <span className="karla-bold text-yellow-100">Prerequisite: </span>
        {`${message} `}
        <a
          href="https://inflight.dope.security/dope.console/settings/importing-from-google"
          target="_blank"
          className="karla-bold text-yellow-100"
        >
          <span className="hover:underline decoration-0">Help me do this</span>
          &nbsp;&nbsp;
          <ArrowIcon
            height={12}
            width={24}
            classes="text-yellow-100 inline-block"
            strokeWidth={0.1}
          />
        </a>
      </p>
    </div>
  )
}
